import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	newField: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.new-field',
		defaultMessage: 'New Field',
		description: 'Label for lozenge to indicate this third party field will create a new field',
	},
	required: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.required',
		defaultMessage: 'Required',
		description: 'Label for lozenge to indicate this field is required',
	},
	requiredFieldToolTip: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.required-field-tool-tip',
		defaultMessage: "This field can't be modified or excluded from the import.",
		description: 'Tool tip content shown when the field is required and can not be excluded',
	},
});
